var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{attrs:{"color":"blue"}},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }